<!-- 违背原因列表 -->
<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      close-icon="close"
      :close-on-popstate="true"
      closeable
      round
    >
      <ld-header :title="title">
        <span slot="left" />
      </ld-header>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(info, index) in list"
            clickable
            :key="index"
            @click.stop="onSelect(info, index);toggle();"
          >
            <span slot="title">{{ info.cName }}</span>
            <van-radio
              slot="right-icon"
              :name="info"
            />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Cell, RadioGroup, Radio } from 'vant'

export default {
  name: 'CancelReason',
  components: {
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell
  },
  props: {
    title: {
      type: String,
      default: '请选择'
    },
    parNo: {
      type: [String, Number],
      default:() => {}
    }
  },
  data() {
    return {
      radio: {},
      list: [],
      isShow: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList() {
      this.$api['common/getBClass']({
        parNo: this.parNo
      }).then(res => {
        let cache = res.data.list || {}
        this.list = cache || []
        this.onSelect(this.list[0])
      })
    },
    onSelect(info) {
      this.radio = info
      this.$emit('selected', info)
    },
    toggle() {
      this.isShow = !this.isShow
    }
  }
}
</script>